import React from 'react';

// SVG-иконки из макета онбординга. Всё, что не имя иконки, считается путём к картинке.
const PATHS = {
  star: (c) => <path d="M12 3l2.6 5.6L20 9.3l-4 4 1 5.7-5-2.8-5 2.8 1-5.7-4-4 5.4-.7z" fill={c} />,
  modules: (c) => (
    <>
      <rect x="4" y="4" width="7" height="7" rx="2" fill="none" stroke={c} strokeWidth="2.2" />
      <rect x="13" y="4" width="7" height="7" rx="2" fill="none" stroke={c} strokeWidth="2.2" />
      <rect x="4" y="13" width="7" height="7" rx="2" fill="none" stroke={c} strokeWidth="2.2" />
      <rect x="13" y="13" width="7" height="7" rx="2" fill={c} />
    </>
  ),
  merge: (c) => <path d="M6 4v5a6 6 0 0 0 12 0V4M12 15v5" fill="none" stroke={c} strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" />,
  growth: (c) => <path d="M4 18l6-6 4 4 6-8M14 8h6v6" fill="none" stroke={c} strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" />,
  shield: (c) => <path d="M12 2l8 3v6c0 5-3.4 9.3-8 11-4.6-1.7-8-6-8-11V5z" fill="none" stroke={c} strokeWidth="2.2" strokeLinejoin="round" />,
  cards: (c) => (
    <>
      <rect x="5" y="4" width="10" height="14" rx="2" fill="none" stroke={c} strokeWidth="2.2" />
      <rect x="9" y="7" width="10" height="14" rx="2" fill="#14101f" stroke={c} strokeWidth="2.2" />
    </>
  ),
  compass: (c) => (
    <>
      <circle cx="12" cy="12" r="8.5" fill="none" stroke={c} strokeWidth="2.2" />
      <path d="M15.5 8.5l-2 5.5-5 1.5 2-5.5z" fill={c} />
    </>
  ),
  swords: (c) => <path d="M5 19L19 5M15 5h4v4M9 5H5v4M5 15v4h4M19 15v4h-4" fill="none" stroke={c} strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" />,
  pass: () => (
    <>
      <path d="M12 2l8 3v6c0 5-3.4 9.3-8 11-4.6-1.7-8-6-8-11V5z" fill="#ffd23f" />
      <path d="M12 7l1.5 3.2 3.5.4-2.6 2.4.7 3.5-3.1-1.8-3.1 1.8.7-3.5L7 10.6l3.5-.4z" fill="#8a4b00" />
    </>
  ),
};

export default function OnboardingIcon({ icon, color = '#c8ff2e', size = 22, round = false, className = '' }) {
  const draw = PATHS[icon];
  if (draw) {
    return (
      <svg className={className} width={size} height={size} viewBox="0 0 24 24" aria-hidden="true">
        {draw(color)}
      </svg>
    );
  }
  return (
    <img
      className={className}
      src={icon}
      alt=""
      style={{ width: size, height: size, borderRadius: round ? '50%' : 6 }}
      draggable={false}
    />
  );
}
